import { render, staticRenderFns } from "./member-list.vue?vue&type=template&id=2d3fdc20&scoped=true&"
import script from "./member-list.vue?vue&type=script&lang=js&"
export * from "./member-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3fdc20",
  null
  
)

export default component.exports